
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// Import your views
import HomeView from "views/Index";
import FormPage from "views/formPage";
import LoginPage from "views/admin/loginPage/loginPage";
import Dashbord from "views/admin/dashbord/dashbord";
import Setting from "views/admin/Settings/Settings";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const username = localStorage.getItem('username');
  
    // Protected routes
    const protectedRoutes = ['/sofia/admin/dashboard', '/sofia/admin/settings'];
  
    if (!isLoggedIn || !username) {
      // If not logged in and trying to access a protected route, redirect to login
      if (protectedRoutes.includes(location.pathname)) {
        navigate('/sofia/admin/login');
      }
    } else {
      // If logged in and trying to access the login page, redirect to dashboard
      if (location.pathname === '/sofia/admin/login') {
        navigate('/sofia/admin/dashboard');
      }
    }
  }, [navigate, location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<HomeView />} />
      <Route path="/form" element={<FormPage />} />
      <Route path="/sofia/admin/login" element={<LoginPage />} />
      <Route path="/sofia/admin/dashboard" element={<Dashbord />} />
      <Route path="/sofia/admin/settings" element={<Setting />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);


// import React from "react";
// import ReactDOM from "react-dom/client";  // Ensure correct import
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import "assets/styles/tailwind.css";

// // Import your views
// import HomeView from "views/Index";
// import FormPage from "views/formPage";
// import LoginPage from "views/admin/loginPage/loginPage";
// import Dashbord from "views/admin/dashbord/dashbord";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <BrowserRouter>
//         <Routes> 
//             <Route path="/" element={<HomeView />} />
//             <Route path="/form" element={<FormPage />} />
//             <Route path="/sofia/admin/login" element={<LoginPage />} />
//             <Route path="/sofia/admin/dashbord" element={<Dashbord />} />

//             <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//     </BrowserRouter>
// );
